import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { cohortActions } from '../../../../store';

import type { RootState } from '../../../../store';

export default function useAddCohortServiceClasses() {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const { cohortServiceClasses, loading: serviceClassesLoading } = useSelector(
    (state: RootState) => state.cohorts,
  );

  useEffect(() => {
    dispatch(cohortActions.getCohortServiceClasses({ getAccessTokenSilently }));
  }, [dispatch, getAccessTokenSilently]);

  return { cohortServiceClasses, serviceClassesLoading };
}
